import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserRoles } from "../common/model/UserRole";

@Injectable({
  providedIn: 'root',
})

export class SharedService {

  private messageSource = new BehaviorSubject<string>('');
  private noRoleSubject = new BehaviorSubject<boolean>(true);

  currentpage: string;

  userName = this.messageSource.asObservable();
  email: string;
  changeUserName(userName: string) {
    this.messageSource.next(userName);
  }

  noRoleObs = this.noRoleSubject.asObservable();

  updateNoRole(value: boolean) {
    this.noRoleSubject.next(value);
  }

  isLoggedIn: boolean;
  errorMessage: string;
  previousRouteToEditSite: string;
  isFacilityLinked: boolean;
  UserRoles: UserRoles;
  previousRouteToEditFacility: string;
  disableSideMenu: boolean;
}

